<!-- ================= TOP HEADER ================= -->
<div class="top-header" *ngIf="school">
  <div
    class="container-fluid px-3 px-md-5 d-flex flex-column flex-md-row justify-content-between align-items-center py-2 text-white">

    <!-- CONTACT INFO -->
    <div class="contact-info text-center text-md-start">
      <strong *ngIf="!isMobile">Get in touch!</strong>

      <ng-container *ngIf="school.cnctMobNum">
        <i class="fas fa-phone-alt ms-2"></i>&nbsp;

        <span *ngIf="school.cnctMobNum">
          {{ school.cnctMobNum }}
        </span>

        <!-- <span *ngIf="school?.phone2">
          {{ school.phone2 }}
        </span> -->
      </ng-container>

      <span class="divider d-md-inline" *ngIf="school.schAddLine">|</span>

      <ng-container *ngIf="school.schAddLine">
        <i class="fas fa-home"></i>&nbsp;
        <span>{{ school.schAddLine }}</span>
      </ng-container>
    </div>

    <!-- CODES -->
    <div class="codes text-center text-md-end">
      <span
        class="text-warning fw-semibold"
        *ngIf="govtCodes.affiliationNo">
        CBSE Affiliation No. {{ govtCodes.affiliationNo }}
      </span>

      <span
        class="divider d-md-inline"
        *ngIf="govtCodes.affiliationNo && govtCodes.schoolCode">
        |
      </span>

      <span
        class="text-dark fw-semibold"
        *ngIf="govtCodes.schoolCode">
        School Code: {{ govtCodes.schoolCode }}
      </span>
    </div>
    <div>
            
    </div>
  </div>
</div>

<!-- ================= NAVBAR ================= -->
<nav class="navbar navbar-expand-lg bg-light">
  <div class="container-fluid">

    <!-- LOGO -->
    <div class="navbar-brand d-flex align-items-center" *ngIf="school">
      <a [routerLink]="['/home']" class="sch-logo-link">
        <img
          *ngIf="school.schImg.fileUUID"
          [src]="getFilePath(school.schImg.fileUUID)"
          alt="School Logo"
          class="sch-logo" />
          <!-- assets/ivsLogo.jpg -->
      </a>

      <div class="ms-1 sch-name-div">
        <span *ngIf="school.schName">{{ school.schName }}</span>
      </div>
    </div>

    <!-- PAY FEES -->
    <button class="pay-fees-btn" (click)="openPayFeesLink()">
      Pay Fees
    </button>

    <!-- MOBILE TOGGLE -->
    <button
      class="navbar-toggler"
      type="button"
      (click)="toggleMenu()"
      aria-label="Toggle navigation">
      <span *ngIf="!isMenuOpen" class="fas fa-bars"></span>
      <span *ngIf="isMenuOpen" class="fas fa-times"></span>
    </button>

    <!-- MENU -->
    <div class="collapse navbar-collapse justify-content-center"
         [class.show]="isMenuOpen">
      <ul class="navbar-nav">

        <li class="nav-item">
          <a class="nav-link" routerLink="/home" routerLinkActive="active">Home</a>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
            About Us
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/aboutUs">About Institution</a>
            <a class="dropdown-item" routerLink="/directorMsg">People Behind the Vision</a>
          </div>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
            Academic
          </a>
          <div class="dropdown-menu">
            <a class="dropdown-item" routerLink="/academic">Admissions</a>
            <a class="dropdown-item" routerLink="/curriculum">Curriculum CBSE</a>
            <a class="dropdown-item" routerLink="/guidelines">Guidelines</a>
          </div>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="/gallery">Gallery</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="/news">News</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="/pubDis">Public Disclosure</a>
        </li>

        <li class="nav-item">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>

      </ul>
    </div>
  </div>
</nav>
